import {
    GuiaTarifaActionTypes,
    MARK_GUIA_TARIFA_DIRTY,
    RESET_GUIA_TARIFA,
    SET_GUIA_TARIFA_ERROR,
    SET_GUIA_TARIFA_LOADING,
    SET_GUIA_TARIFA_SUCCESS
} from "../types/guiaTarifaActionTypes";
import { IGuiaTarifa } from "../../entities/guias/IGuiaTarifa";

export function setGuiaTarifaLoading(): GuiaTarifaActionTypes {
    return { type: SET_GUIA_TARIFA_LOADING };
}

export function setGuiaTarifaSuccess(
    payload: Omit<IGuiaTarifa, 'status' | 'errorMessage' | 'dirty'>
): GuiaTarifaActionTypes {
    return { type: SET_GUIA_TARIFA_SUCCESS, payload };
}

export function setGuiaTarifaError(errorMessage: string): GuiaTarifaActionTypes {
    return { type: SET_GUIA_TARIFA_ERROR, errorMessage };
}

export function resetGuiaTarifa(): GuiaTarifaActionTypes {
    return { type: RESET_GUIA_TARIFA };
}

export function markGuiaTarifaDirty(): GuiaTarifaActionTypes {
    return { type: MARK_GUIA_TARIFA_DIRTY };
}
